export default __webpack_public_path__ + "static/media/facebook-color.5f603d54.svg";